import {useWorkspaceEventTemplates} from "~/contexts/workspaceContext";

export function useEventTemplates() {
    return useWorkspaceEventTemplates();
}
